import React, { FC, ReactElement, ReactNode } from 'react'
import { T } from '@transifex/react'
import { Anchor, Col, Row } from 'antd'
import { AnchorContainer } from 'antd/lib/anchor/Anchor'

import { LayoutWithDividerv3 } from 'src/layouts'
import { Typography } from 'src/storybook/components'

import LayoutFormScrollableDivider from './LayoutFormScrollableDivider'
import { TFormSectionProps } from '../FormSection'

export type TLayoutFormAnchorProps = {
  footer?: ReactNode
  anchorListTitle?: ReactNode
  dividerWidth?: number
}

const LayoutFormAnchor: FC<TLayoutFormAnchorProps> = ({
  footer,
  children,
  anchorListTitle,
  dividerWidth = 1,
}) => {
  const anchors = React.Children.map(
    children as ReactElement[],
    (child: ReactElement<TFormSectionProps>) => ({
      label: child?.props?.anchorTitle || child?.props?.title,
      anchor: child?.props?.id,
    })
  ).filter(({ anchor, label }) => anchor && label) as {
    label: ReactNode
    anchor: string
  }[]

  const scrollerClass = 'scroller-container'

  const childToRender = (
    <LayoutFormScrollableDivider scrollerClass={scrollerClass} footer={footer}>
      {children}
    </LayoutFormScrollableDivider>
  )

  return (
    <LayoutWithDividerv3
      colsProps={[
        {
          style: {
            width: 200,
          },
          flex: undefined,
        },
      ]}
      style={{ height: '100%' }}
      dividerWidth={dividerWidth}
      dividerMargin={0}
      className="wrapper"
      dividerWrapperProps={{ style: { height: '100%' } }}
      wrapperColProps={{ style: { height: '100%' } }}
      content={[
        <Row style={{ padding: '1rem' }} gutter={[0, 16]}>
          <Col xs={24}>
            <Typography variant="subHeader-16" weight="semi-bold">
              {anchorListTitle || <T _str="Setting menu" />}
            </Typography>
          </Col>
          <Col xs={24}>
            <Anchor
              offsetTop={32}
              getContainer={() =>
                document.getElementsByClassName(
                  scrollerClass
                )?.[0] as AnchorContainer
              }
              items={anchors.map(({ anchor, label }) => ({
                key: anchor,
                href: `#${anchor}`,
                title: label,
              }))}
            />
          </Col>
        </Row>,
        childToRender,
      ]}
    />
  )
}

export default LayoutFormAnchor
